import {Col, Form, Row, Select} from 'antd'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {DEFAULT_CURRENCY, currencies as defaultCurrencies} from '@/constants/currencies'
import {AmountFormField} from '@/components'
import {CURRENCY_ID} from '@/constants/playwright-ids'
import {AmountCurrencyFormFieldProps} from './props'

export const AmountCurrencyFormField: React.FC<AmountCurrencyFormFieldProps> = (props) => {
    const {t} = useTranslation()
    const {
        form,
        label = t('AmountFormField.amount'),
        amountName = 'amount',
        currencyName = 'currency',
        currency = DEFAULT_CURRENCY,
        inputProps,
        selectProps,
        currencies = defaultCurrencies,
        rules,
        isRequired,
        dependencies,
        shouldAcceptZero
    } = props
    const showCurrency = currencies?.length >= 1 || form.getFieldValue(currency) !== DEFAULT_CURRENCY

    return (
        <Row gutter={[8, 0]}>
            <Col xs={12}>
                <Form.Item label={label}>
                    <AmountFormField
                        name={amountName}
                        currency={currency}
                        form={form}
                        label={null}
                        noStyle
                        inputProps={{
                            prefix: null,
                            ...inputProps
                        }}
                        shouldAcceptZero={shouldAcceptZero}
                        rules={rules}
                        isRequired={isRequired}
                        dependencies={dependencies}
                    />
                </Form.Item>
            </Col>
            <Col xs={12} style={{display: showCurrency ? 'block' : 'none'}}>
                <Form.Item label={t('AmountFormField.currency')} name={currencyName}>
                    <Select {...selectProps} data-test-id={CURRENCY_ID}>
                        {currencies.map((item) => (
                            <Select.Option key={item} value={item} data-test-id={item}>
                                {item}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </Col>
        </Row>
    )
}
